import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import Container from 'bundles/degree-description/components/shared/Container';

type Props = {
  content: React.ReactElement;
  /**
   *  Props for DDP Revamp 2.3 Hero module change
   *  sidebarContent: renderProps for content on the right side of informational section
   */
  sidebarContent?: React.ReactElement;
};

const InfomationalSectionContainer: React.FC<Props> = ({ content, sidebarContent }) => {
  return (
    <Container>
      <Grid container spacing={16}>
        <Grid item xs={12} md={8}>
          {content}
        </Grid>
        {sidebarContent && (
          <Grid item xs={12} md={4}>
            {sidebarContent}
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default InfomationalSectionContainer;
